export const LANGUAGES = [
    {
        "language": "English",
        "code": "en"
    },
    {
        "language": "Mandarin Chinese",
        "code": "zh"
    },
    {
        "language": "Hindi",
        "code": "hi"
    },
    {
        "language": "Spanish",
        "code": "es"
    },
    {
        "language": "French",
        "code": "fr"
    },
    {
        "language": "Arabic",
        "code": "ar"
    },
    {
        "language": "Bengali",
        "code": "bn"
    },
    {
        "language": "Portuguese",
        "code": "pt"
    },
    {
        "language": "Russian",
        "code": "ru"
    },
    {
        "language": "Urdu",
        "code": "ur"
    },
    {
        "language": "Japanese",
        "code": "ja"
    }
];
